import { getFQDNFromString } from '../../../../_metronic/helpers';

export enum SocialMedia {
  FACEBOOK = 'FACEBOOK',
  MESSENGER = 'MESSENGER',
  INSTAGRAM = 'INSTAGRAM',
  WHATSAPP = 'WHATSAPP',
  X = 'X',
  LINKEDIN = 'LINKEDIN',
  YOUTUBE = 'YOUTUBE',
  PINTEREST = 'PINTEREST',
  REDDIT = 'REDDIT',
  SNAPCHAT = 'SNAPCHAT',
  THREADS = 'THREADS',
  MASTODON = 'MASTODON',
  DISCORD = 'DISCORD',
  FLICKR = 'FLICKR',
  TUMBLR = 'TUMBLR',
  LINE = 'LINE',
  TELEGRAM = 'TELEGRAM',
  TIKTOK = 'TIKTOK',
  WEIBO = 'WEIBO',
  WECHAT = 'WECHAT',
  QQ = 'QQ',
  XIAOHONGSHU = 'XIAOHONGSHU',
  TWITCH = 'TWITCH',
  BLUESKY = 'BLUESKY',
}

export const getSocialMediaFromLink = (link: string): SocialMedia => {
  const socialMediaDomainsMap: Record<SocialMedia, string[]> = {
    [SocialMedia.FACEBOOK]: ['facebook', 'fb.me', 'fb'],
    [SocialMedia.MESSENGER]: ['m.me'],
    [SocialMedia.INSTAGRAM]: ['instagram'],
    [SocialMedia.WHATSAPP]: ['whatsapp', 'wa.me'],
    [SocialMedia.X]: ['twitter', 'x'],
    [SocialMedia.LINKEDIN]: ['linkedin'],
    [SocialMedia.YOUTUBE]: ['youtube'],
    [SocialMedia.PINTEREST]: ['pinterest'],
    [SocialMedia.REDDIT]: ['reddit'],
    [SocialMedia.SNAPCHAT]: ['snapchat'],
    [SocialMedia.THREADS]: ['threads'],
    [SocialMedia.MASTODON]: ['mastodon'],
    [SocialMedia.DISCORD]: ['discord', 'discord.gg'],
    [SocialMedia.FLICKR]: ['flickr'],
    [SocialMedia.TUMBLR]: ['tumblr'],
    [SocialMedia.LINE]: ['line.me', 'lin.ee'],
    [SocialMedia.TELEGRAM]: ['t.me', 'telegram.me'],
    [SocialMedia.TIKTOK]: ['tiktok', 'douyin'],
    [SocialMedia.WEIBO]: ['weibo'],
    [SocialMedia.WECHAT]: ['weixin.qq'],
    [SocialMedia.QQ]: ['qq'],
    [SocialMedia.XIAOHONGSHU]: ['xiaohongshu'],
    [SocialMedia.TWITCH]: ['twitch.tv'],
    [SocialMedia.BLUESKY]: ['bsky.app'],
  };

  const fqdn = getFQDNFromString(link);

  if (!fqdn) return null;

  const socialMediaRegexes = {};
  for (const [media, domains] of Object.entries(socialMediaDomainsMap)) {
    socialMediaRegexes[media] = [];
    for (const domain of domains) {
      socialMediaRegexes[media].push(new RegExp(`\\b${domain}\\b`, 'i'));
    }
  }

  for (const [media, domains] of Object.entries(socialMediaRegexes)) {
    for (const domain of domains as RegExp[]) {
      if (domain.test(fqdn)) {
        return SocialMedia[media];
      }
    }
  }

  return null;
};

export const messengerSocialMedias = [SocialMedia.WHATSAPP];
